import request from '@/utils/request'
import { Message } from 'element-ui'
import { workOrderApiParamsVerify } from '@/utils/regular'
import { INTERFACE_SPLITS } from '@/constants/module/interface'

// 校验是否是订单号
function isOrderId(order_id) {
  if (typeof order_id == 'number') {
    return true
  }
  return order_id && typeof order_id == 'string' && (/(^[1-9]\d*$)/.test(order_id))
}

// 订单号错误提示
function errPromise() {
  return new Promise((resolve, reject) => {
    Message({
      message: '非法订单号',
      type: 'error',
    })
    reject('非法订单号')
  })
}

/**
 * @description: 客诉工单详情
 * @param {*} params {id} 工单id
 * @param {*} type 查看、编辑接口进行拆分，目的是对信息进行脱敏操作 枚举值为view、edit
 * @return {*}
 */
export function getworkOrderInfo(params, type = 'view') {
  return request({
    url: `${INTERFACE_SPLITS.WORK_ORDER_DETAIL[type]}`,
    method: 'get',
    params
  })
}

// 报备工单受理
export function reportHandle(params) {
  return request({
    url: '/admin/v1/workOrderInfo/reportHandle',
    method: 'POST',
    data: params
  })
}

// 客诉工单受理
export function complaintHandle(params) {
  return request({
    url: '/admin/v1/workOrderInfo/complaintHandle',
    method: 'post',
    data: params
  })
}
// 申诉工单受理
export function appealHandle(params) {
  return request({
    url: '/admin/v1/workOrderInfo/appealHandle',
    method: 'post',
    data: params
  })
}

// 追加工单描述
export function addDesc(params) {
  return request({
    url: '/admin/v1/workOrderInfo/addDesc',
    method: 'put',
    data: params
  })
}

// 渠道自动判责申诉
export function getworkOrderCustomerComplaint(id, params) {
  return request({
    url: `/admin/v1/workOrderInfo/agentAppeal/${id}`,
    method: 'put',
    data: params
  })
}

/**
 * @description: 获取订单所有司机
 * @param {*} params {order_id} 订单id
 * @param {*} type 查看、编辑接口进行拆分，目的是对信息进行脱敏操作 枚举值为view、edit
 * @return {*}
 */
export function getworkOrderAllDriver(params, type = 'view') {
  // 判断orderId、workId参数是否正确
  if (workOrderApiParamsVerify(params)) {
    return Promise.reject('入参错误')
  }
  return request({
    url: `${INTERFACE_SPLITS.ORDER_ALL_DRIVER[type]}`,
    method: 'get',
    params
  })
}

// 获取虚拟号
export function getVirtualPhoneNumber(id, params) {
  return request({
    url: `/admin/v1/workOrderInfo/worksheetBindPhone`,
    method: 'get',
    params
  })
}

// 工单详情内部备注列表查询
export function getworkOrderRemakeList(params) {
  return request({
    url: '/admin/v1/workOrderInfo/GetLogPageByWorkId',
    method: 'get',
    params
  })
}

// 添加内部备注
export function addInsertInnerRemarkLog(params) {
  return request({
    url: '/admin/v1/workOrderInfo/insertInnerRemarkLog',
    method: 'post',
    data: params
  })
}

// 催单述列表
export function addWorkOrderAdditional(params) {
  return request({
    url: '/admin/v1/workOrderAdditional/insert',
    method: 'post',
    data: params
  })
}

// 获取订单关联工单列表（排除当前工单）
export function getListRelationWorkOrder(params) {
  if (params.order_id && !isOrderId(params.order_id)) {
    return errPromise()
  }
  return request({
    url: '/admin/v1/workOrderInfo/listRelationWorkOrder',
    method: 'get',
    params
  })
}

// 工单标签树形列表
export function getWorkOrderLabelTree(params) {
  return request({
    url: '/admin/v1/workOrderLabel/tree',
    method: 'get',
    params
  })
}

// 历史记录
export function getWorkOrderLogs(id, params) {
  if (id && !isOrderId(id)) {
    return errPromise()
  }
  return request({
    url: `/admin/v1/getWorkOrderLogs/${id}`,
    method: 'get',
    params
  })
}

// 司机累积处罚
export function getDriverPunishInfoByLevel(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getDriverPunishInfoByLevel',
    method: 'get',
    params
  })
}
// 获取优惠券列表
export function getCouponList(params) {
  return request({
    url: '/admin/v1/workOrderInfo/couponList',
    method: 'get',
    params
  })
}
// 获取工单责任方标签
export function getResponsibleLabel(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getResponsibleLabel',
    method: 'get'
  })
}

// 获取订单费用详情接口
export function getChargeCenterOrderFee(params) {
  if (params.order_id && !isOrderId(params.order_id)) {
    return errPromise()
  }
  return request({
    url: '/admin/v1/workOrderInfo/getChargeCenterOrderFee',
    method: 'get',
    params
  })
}

// 获取订单费用详情接口
export function getOrderFeeDetail(params) {
  if (params.order_id && !isOrderId(params.order_id)) {
    return errPromise()
  }
  return request({
    url: '/admin/v1/workOrderInfo/getOrderFeeDetail',
    method: 'get',
    params
  })
}

// 改价免单 获取订单费用详情接口
export function getOrderTotalFee(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getOrderTotalFee',
    method: 'get',
    params
  })
}

// 辅助判责
export function judgeHelp(params) {
  return request({
    url: '/admin/v1/workOrderInfo/judgeHelp',
    method: 'get',
    params
  })
}
// 辅助判责
export function getWorkOrderGroupDetail(params) {
  return request({
    url: '/admin/v1/workOrderGroup/getById',
    method: 'get',
    params
  })
}

// 获取追加描述列表
export function getWorkOrderAdditional(params) {
  return request({
    url: '/admin/v1/workOrderAdditional/list',
    method: 'get',
    params
  })
}
// 获取司机车队分别退费金额（废弃）
export function getDriverVendorSettlementByAll(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getDriverVendorSettlementByAll',
    method: 'get',
    params
  })
}
// 获取司机车队总退费金额
export function getSettlementByPassengerRefund(params) {
  return request({
    url: '/admin/v1/workOrderInfo/getSettlementByPassengerRefund',
    method: 'get',
    params
  })
}

// 获取司机车队总退费金额
export function getRelationWorkOrderInfoBySettleType(params) {
  if (params.order_id && !isOrderId(params.order_id)) {
    return errPromise()
  }
  return request({
    url: '/admin/v1/workOrderComplaintResult/getRelationWorkOrderInfoBySettleType',
    method: 'get',
    params
  })
}

// 上传图片
export function localUpload(params) {
  return request({
    url: '/admin/v1/workOrderInfo/upload',
    method: 'POST',
    data: params
  })
}

// 获取违规等级
export function getPunishLabels(params) {
  return request({
    url: '/admin/v1/workOrderPunishLabel/getPunishLabels',
    method: 'get',
    params
  })
}

// 获取违规标签详情
export function getPunish(params) {
  return request({
    url: '/admin/v1/workOrderPunishLabel/getPunish',
    method: 'get',
    params
  })
}

// 受理的时候添加受理时间记录
export function handleStart(params) {
  return request({
    url: '/admin/v1/workOrderInfoExtension/handleStart',
    method: 'POST',
    data:params
  })
}

// 申诉受理之前获取补分
export function handleGetAppealInfo(params){
  return request({
    url: '/admin/v1/workOrderInfo/getAppealInfo',
    method: 'POST',
    data:params
  })
}

// 无订单创建工单受理
export function handleInnerWorkOrderHandle(params){
  return request({
    url: '/admin/v1/workOrderInfo/innerWorkOrderHandle',
    method: 'POST',
    data:params
  })
}

// 工单升级流转组
export function handleUpgradeWorkOrder(params){
  return request({
    url: '/admin/v1/workOrderInfoExtension/upgradeWorkOrder',
    method: 'POST',
    data:params
  })
}

// 立即发送短信
export function workOrderSms(params){
  return request({
    url: '/admin/v1/workOrderSms/insert',
    method: 'POST',
    data:params
  })
}

// 工单挂起
export function hangupWorkOrder(params){
  return request({
    url: '/admin/v1/workOrderInfoExtension/hangupWorkOrder',
    method: 'POST',
    data:params
  })
}

// 获取渠道
export function getAgents() {
  return request({
    url: '/admin/v1/paycenter/queryAgents',
    method: 'get',
    data: {}
  })
}

// 改价校验
export function getChangePriceCheck(data) {
  return request({
    url: '/admin/v1/order/changePrice/check',
    method: 'post',
    data: data
  })
}

// 根据工单标题获取司机违规信息
export function getPunishByID(params) {
  return request({
    url: '/admin/v1/workOrderPunishLabel/getPunishByID',
    method: 'get',
    params
  })
}

// 工单受理自动获取司乘结案陈词
export function getWorkOrderTemplateInfo(params) {
  return request({
    url: '/admin/v1/workOrderTemplate/getInfo',
    method: 'get',
    params
  })
}

// 根据订单id获取司机/乘客详细费用
export function getDriverPsgFeeDetail(params) {
  if (!params.order_id) {
		return errPromise()
	}
  if (params.order_id && !isOrderId(params.order_id)) {
    return errPromise()
  }
  return request({
    url: '/admin/v1/complaint/getDriverPsgFeeDetail',
    method: 'get',
    params
  })
}

// 根据乘客改价账单计算司机改价账单
export function getDriverDetailFee(params) {
  return request({
    url: '/admin/v1/complaint/getDriverDetailFee',
    method: 'get',
    params
  })
}

// 根据订单id获取该订单历史操作改价信息
export function getComplaintExts(params) {
  if (!params.order_id || !isOrderId(params.order_id)) {
    return errPromise()
  }
  return request({
    url: '/admin/v1/complaint/getComplaintExts',
    method: 'get',
    params
  })
}

// 获取申诉工单结案陈词接口
export function getAppealHandleResult(params) {
  return request({
    url: '/admin/v1/workOrderInfo/appealHandleResult',
    method: 'get',
    params
  })
}

// 绑定虚拟号
export function getVirtualBind(data) {
  return request({
    url: '/admin/v1/workOrderInfo/bind',
    method: 'POST',
    data: data
  })
}

/**
 * 获取settle_amount费用
 * @param {Number} params.deduct_travel_fee 行程费 单位(分)
 * @param {Number} params.deduct_road_fee 过路费 单位(分)
 * @param {Number} params.parking_fee 停车费 单位(分)
 * @returns
 */
export function getDriverVendorSettlementByDeduct(data) {
  return request({
    url: '/admin/v1/workOrderInfo/getDriverVendorSettlementByDeduct',
    method: 'POST',
    data
  })
}
/**
 * 获取一线工作台操作历史
 * @param {Number} params.work_id 行程费 单位(分)
 * @returns
 */
export function getHistoryFrontLog(params) {
	return request({
		url: '/admin/v1/workFront/getHistoryFrontLog',
		method: 'GET',
		params
	})
}
/**
 * 乘客侧计算预估退款差价
 * @param {Number} params.order_id 订单id
 * @returns
 */
export function getEstimateRefund(params) {
	return request({
		url: '/admin/v1/workOrderInfo/getEstimateRefund',
		method: 'GET',
		params
	})
}

// 根据工单id查询携程违规申诉详情
export function getCtripViolationAppealByWorkId(params) {
	return request({
		url: '/admin/v1/ctripViolationAppeal/getCtripViolationAppealByWorkId',
		method: 'GET',
		params
	})
}

// 携程违规申诉
export function getCtripViolationAppeal(data) {
	return request({
		url: '/admin/v1/ctripViolationAppeal/appeal',
		method: 'PUT',
		data
	})
}
